// Thème du tableau de bord : une classe theme-<id> sur <body>, mémorisée sur le poste.
// Se choisit dans l'onglet Réglages du menu de droite. Le thème classique est celui par défaut.
const CLE = "theme";
export const THEMES = ["classique", "jeu-video", "final-fantasy"];
const PAR_DEFAUT = "classique";

function lire() {
    try {
        const theme = localStorage.getItem(CLE);
        return THEMES.includes(theme) ? theme : PAR_DEFAUT;
    } catch (e) {
        return PAR_DEFAUT;
    }
}

export function themeActif() {
    return THEMES.find(theme => document.body.classList.contains("theme-" + theme)) || "classique";
}

export function appliquerTheme(theme = lire()) {
    THEMES.forEach(id => document.body.classList.toggle("theme-" + id, id === theme && id !== "classique"));
}

export function choisirTheme(theme) {
    try {
        localStorage.setItem(CLE, theme);
    } catch (e) {
        // le choix vaudra pour cette page seulement
    }
    appliquerTheme(theme);
}
